"use client";

import { useEffect } from "react";

import { pushEvent } from "@/lib/analytics";
import type { ViewItemEvent } from "@/lib/analytics";

type ViewItemTrackerProps = Omit<ViewItemEvent, "event">;

export function ViewItemTracker({
  item_id,
  item_name,
  item_category,
  value,
}: ViewItemTrackerProps): null {
  useEffect(() => {
    pushEvent({ event: "view_item", item_id, item_name, item_category, value });
  }, [item_id, item_name, item_category, value]);

  return null;
}
